import { useState } from "react";
import { JOB_STEPS } from "../CreateJobPage";
import CustomInputV2 from "@components/CustomInputV2/CustomInputV2";
import { Check } from "lucide-react";

const TABS = [
  {
    label: "Job Description",
    value: 1,
  },
  {
    label: "Skills and Experience",
    value: 2,
  },
];

const publicationChecks = [
  "Hiring company and role facts confirmed",
  "Candidate-facing description reviewed",
  "3 contextual skill requirements included",
  "Requirement source retained for agency records",
];

const Step5 = ({ activeStep }) => {
  const [selectedPostType, setSelectedPostType] = useState(1);

  return (
    <>
      {/* Header */}
      <div className="flex border-b pb-3">
        <div className="flex flex-col gap-0.5 flex-1">
          <span className="text-xss font-bold text-light-black uppercase">
            Step {String(activeStep).padStart(2, "0")} /{" "}
            {JOB_STEPS[activeStep - 1]?.label}
          </span>
          <span className="font-semibold text-xl">
            {JOB_STEPS[activeStep - 1]?.title}
          </span>
          <span className="text-xss font-medium text-light-black">
            {JOB_STEPS[activeStep - 1]?.subtitle}
          </span>
        </div>
        <span className="self-end text-xss font-bold text-light-black uppercase leading-3">
          {JOB_STEPS[activeStep - 1]?.tagline}
        </span>
      </div>
      {/* Job details */}
      <div className="flex flex-col rounded-md border overflow-hidden mt-5">
        <div className="flex justify-between p-4 border-b">
          <div className="flex items-center gap-4">
            <div className="h-11 w-11 rounded-md bg-charcoal flex items-center justify-center font-bold text-md text-white">
              G
            </div>
            <div className="flex flex-col gap-1">
              <span className="font-semibold text-lg">
                Cyber Security Analyst
              </span>
              <span className="font-bold text-xss">Google</span>
              <div className="flex items-center gap-4">
                <span className="text-xss font-medium text-light-black">
                  London hybrid
                </span>
                <span className="text-xss font-medium text-light-black">
                  Permanent / Full time
                </span>
                <span className="text-xss font-medium text-light-black">
                  £65,000–£78,000 per year
                </span>
              </div>
            </div>
          </div>
          <div className="rounded-full uppercase border font-bold text-xsss px-2 py-1 text-slate-600 h-max">
            candidate preview
          </div>
        </div>

        <div className="flex items-center border-b p-4 gap-8">
          {TABS?.map((tab) => {
            return <div className="font-bold text-xss">{tab?.label}</div>;
          })}
        </div>

        <div className="flex flex-col gap-4 p-4">
          <div className="flex flex-col gap-2">
            <span className="font-bold text-xss uppercase tracking-widest text-slate-600">
              Published job description
            </span>
            <span className="font-medium text-xss text-light-black">
              Google is looking for a Cyber Security Analyst to protect internal
              platforms and customer-facing services by monitoring threats,
              investigating incidents and strengthening practical security
              controls. The successful applicant will work with engineering,
              risk and business teams to improve resilience and turn security
              findings into clear action.
            </span>
          </div>
          <div className="flex flex-col gap-2">
            <span className="font-bold text-sm text-black">
              Key responsibilities
            </span>
            <span className="font-medium text-xss text-light-black">
              Google is looking for a Cyber Security Analyst to protect internal
              platforms and customer-facing services by monitoring threats,
              investigating incidents and strengthening practical security
              controls. The successful applicant will work with engineering,
              risk and business teams to improve resilience and turn security
              findings into clear action.
            </span>
          </div>
        </div>
      </div>

      {/* Publication checks */}
      <div className="flex items-center px-4 py-3.5 rounded-md border bg-slate-50 mt-5 gap-10">
        <span className="font-bold text-xss text-light-black uppercase tracking-wide">
          Publication checks
        </span>
        <div className="grid grid-cols-2 gap-1 col-span-5 gap-x-10">
          {publicationChecks?.map((publication) => {
            return (
              <div className="flex items-center text-xss font-medium text-light-black gap-1">
                <Check size={12} strokeWidth={3.5}/>
                {publication}</div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Step5;
